<div class="block-questions">
  @if (!isSecondChild() && questionRows$().length === 0) {
    <button
      mat-stroked-button
      color="primary"
      class="block-questions__add-button"
      data-testid="block-questions-add-initial-question-button"
      (click)="onAddQuestion()"
    >
      <fa-icon [icon]="faPlus"></fa-icon>
      Add initial question
    </button>
  } @else {
    @if (questionRows$().length > 0) {
      <div class="block-questions__q-list">
        @for (row of questionRows$(); track row.question.id) {
          <div class="block-questions__q-list-row">
            <div class="block-questions__q-list-question">
              <fa-icon [icon]="questionTypeConfig[row.question.type].icon"></fa-icon>
              <div class="block-questions__q-list-question-title">
                <span class="fs__sm fw__600">{{ row.question.code }}.</span>
                <span class="block-questions__q-list-question-text survey-editor__html-content fs__sm" [innerHTML]="row.question.title | toPlainText"></span>
              </div>
            </div>
            @if (isMediaLoop$()) {
              <mat-slide-toggle
                color="primary"
                [checked]="row.showStimulus"
                [attr.data-testid]="'loop-show-stimulus-' + row.question.id + '-toggle'"
                (change)="onShowStimulus(row.question.id, $event.checked)"
                ><span>Show stimulus</span></mat-slide-toggle
              >
            }
            @if (row.isLast) {
              <button
                mat-icon-button
                title="Remove block"
                color="warn"
                [attr.data-testid]="'block-questions-remove-' + row.question.id + '-button'"
                (click)="onRemoveLastQuestion()"
              >
                <fa-icon [icon]="faTrashCan"></fa-icon>
              </button>
            }
          </div>
        }
      </div>
    }

    @if (nextQuestion$()) {
      <button
        mat-stroked-button
        color="primary"
        class="block-questions__add-button"
        data-testid="block-questions-add-next-question-button"
        (click)="onAddNextSequentialQuestion()"
      >
        <fa-icon [icon]="faPlus"></fa-icon>
        Add "{{ nextQuestion$().code }} - {{ nextQuestion$().title | toPlainText }}"
      </button>
    } @else if (siblingWithoutQuestions$()) {
      <span class="block-questions__q-not-available fs__sm fw__ 500">
        It looks like you've created multiple blocks. Please add at least one question to each previous block before adding questions here.
      </span>
    } @else {
      <span class="block-questions__q-not-available fs__sm fw__ 500">No more questions available to include on this block</span>
    }
  }
</div>
